// Store-side service packages: the Packages tab, selling a package and the customer card.
// Deep-merged into the main bundle in i18n.js.

export const servicePackageManagementTranslationsEn = {
  servicePackagesManagement: {
    addNew: 'Add package',
    noPackages: 'No packages yet',
    emptyHint: 'Create a prepaid package, such as 10 haircuts, that customers buy once and use on their bookings.',
    error: {
      noStoreSelected: 'No store selected.',
      loading: 'Failed to load packages.',
      create: 'Failed to create the package.',
      update: 'Failed to update the package.',
      activate: 'Failed to activate the package.',
      deactivate: 'Failed to deactivate the package.',
    },
    apiErrors: {
      InvalidServicePackageData: 'Some package details are not valid. Check the name, price, uses, expiry, services and professionals.',
      ServicePackageNotFound: 'This package no longer exists.',
      ServicePackageInactive: 'This package is inactive and cannot be sold.',
      CustomerServicePackageAlreadyActive: 'This customer already has an active copy of this package. It must be used up, expire or be cancelled before selling it again.',
      CustomerServicePackageNotFound: 'This customer package no longer exists.',
      StorePayOnBookingDisabled: 'In-store package sales are turned off in the payment settings.',
      PlanUpgradeRequired: 'Service packages are available on the Pro plan. Upgrade to unlock them.',
    },
    feedback: {
      created: 'Package created.',
      updated: 'Package updated.',
      activated: 'Package activated.',
      deactivated: 'Package deactivated.',
    },
    actions: {
      edit: 'Edit package',
      activate: 'Activate package',
      deactivate: 'Deactivate package',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    card: {
      unnamed: 'Unnamed package',
      price: 'Price',
      quantity: '{{count}}x',
      expiresAfter_one: 'Expires {{count}} month after purchase',
      expiresAfter_other: 'Expires {{count}} months after purchase',
      noExpiry: 'No expiry',
      includedServices: 'Services',
      professionals: 'Professionals',
      anyProfessional: 'Any professional',
      activeHolders: 'Active holders',
      removedService: 'Removed service',
    },
    activate: {
      title: 'Activate package?',
      message: 'Customers will be able to buy {{name}} again.',
      confirm: 'Activate',
    },
    deactivate: {
      title: 'Deactivate package?',
      message: 'Customers will no longer be able to buy {{name}}. Customers who already bought it can keep using it until it is used up or expires.',
      confirm: 'Deactivate',
    },
    dialog: {
      createTitle: 'New package',
      editTitle: 'Edit package',
      saveCreate: 'Create package',
      saveEdit: 'Save changes',
    },
    fields: {
      name: 'Package name',
      price: 'Price',
      quantity: 'Uses',
      quantityHelp: 'Each booking uses one, however many of the package services it includes.',
      expiresInMonths: 'Expires in (months)',
      expiresInMonthsPlaceholder: 'No expiry',
      expiresInMonthsHelp: 'Leave empty for no expiry. Customers are warned before buying.',
      includedServices: 'Included services',
      includedServicesHelp: 'A booking is covered only when all of its services are in the package.',
      noServicesAvailable: 'There are no active services to include yet.',
      includedProfessionals: 'Professionals',
      includedProfessionalsHelp: 'Leave all unchecked to allow any professional who performs these services. Check specific ones to restrict this package to those team members.',
      noProfessionalsAvailable: 'There are no professionals available.',
    },
    validation: {
      nameRequired: 'Enter the package name for every supported language.',
      priceRequired: 'Enter a price greater than zero.',
      priceDecimals: 'The price can have at most two decimal places.',
      quantityRequired: 'Enter a whole number of uses between 1 and 999.',
      expiresInMonthsInvalid: 'Enter a whole number of months between 1 and 36, or leave it empty.',
      servicesRequired: 'Select at least one service.',
    },
    customer: {
      title: 'Service packages',
      sell: 'Sell package',
      sellUnavailable: 'In-store package sales are turned off in the payment settings.',
      empty: 'This customer has no active packages.',
      remaining: '{{remaining}} of {{total}} remaining',
      expiresOn: 'Expires on {{date}}',
      noExpiry: 'No expiry',
      purchasedOn: 'Bought on {{date}}',
      channel: {
        Online: 'Online',
        InStore: 'In store',
      },
      pastPackages: 'Past packages ({{count}})',
      effectiveStatus: {
        PendingCheckout: 'Awaiting payment',
        Active: 'Active',
        Exhausted: 'Used up',
        Expired: 'Expired',
        Canceled: 'Cancelled',
        Refunded: 'Refunded',
        CheckoutExpired: 'Checkout expired',
      },
      cancel: {
        action: 'Cancel package',
        title: 'Cancel this package?',
        message: 'The customer will no longer be able to book with {{name}}. Bookings already made with it keep their coverage. This does not refund the customer.',
        confirm: 'Cancel package',
        success: 'Package cancelled.',
        error: 'Failed to cancel the package.',
      },
    },
    customerPackages: {
      error: {
        loading: 'Failed to load customer packages.',
      },
      filter: {
        label: 'Show',
        current: 'Current',
        all: 'All',
      },
      empty: {
        title: 'No customer packages yet',
        subtitle: 'Packages your customers buy, online or in store, will appear here.',
        filtered: 'No packages match this filter.',
      },
      table: {
        customer: 'Customer',
        package: 'Package',
        status: 'Status',
        uses: 'Uses',
        channel: 'Channel',
        purchased: 'Bought on',
        expires: 'Expires on',
        price: 'Price',
        actions: 'Actions',
        unnamedCustomer: 'Unnamed customer',
      },
    },
    sell: {
      title: 'Sell package',
      description: 'Record a package the customer pays for in store. It can be used on bookings straight away.',
      customer: 'Customer',
      customerPlaceholder: 'Select a customer',
      package: 'Package',
      packagePlaceholder: 'Select a package',
      noActivePackages: 'There are no active packages to sell. Create one in Services > Packages.',
      summary: 'Summary',
      confirm: 'Sell package',
      selling: 'Selling...',
      success: 'Package sold.',
      error: 'Failed to sell the package.',
      errors: {
        customerRequired: 'Select a customer.',
        packageRequired: 'Select a package.',
      },
    },
    appointment: {
      coveredByPackage: 'Covered by package',
      packageLabel: 'Package: {{name}}',
      packageNote: 'Uses 1 from {{name}}',
      changeToRegularMessage: 'This removes package coverage from the appointment, gives the use back to the customer\'s package and charges regular service prices. This action cannot be undone.',
    },
  },
  servicesManagement: {
    tabs: {
      packages: 'Packages',
      customerPackages: 'Customer Packages',
      customerPackagesShort: 'Customers',
    },
  },
  paymentSettingsPage: {
    customerPayments: {
      step3: {
        packages: 'Packages',
      },
    },
  },
  roles: {
    modal: {
      form: {
        categories: {
          servicePackages: 'Service packages',
        },
      },
    },
  },
  dashboard: {
    kpis: {
      todayServicePackageRevenue: 'Package sales today',
      monthServicePackageRevenue: 'Package sales this month',
    },
    activityTypes: {
      servicePackageSold: '{{customerName}} bought {{planName}}',
      servicePackageRefunded: 'Package refund to {{customerName}} ({{planName}})',
    },
  },
};

export const servicePackageManagementTranslationsPt = {
  servicePackagesManagement: {
    addNew: 'Adicionar pacote',
    noPackages: 'Ainda não há pacotes',
    emptyHint: 'Crie um pacote pré-pago, como 10 cortes de cabelo, que os clientes compram uma vez e usam nas suas marcações.',
    error: {
      noStoreSelected: 'Nenhuma loja selecionada.',
      loading: 'Falha ao carregar os pacotes.',
      create: 'Falha ao criar o pacote.',
      update: 'Falha ao atualizar o pacote.',
      activate: 'Falha ao ativar o pacote.',
      deactivate: 'Falha ao desativar o pacote.',
    },
    apiErrors: {
      InvalidServicePackageData: 'Alguns dados do pacote não são válidos. Verifique o nome, o preço, as utilizações, a validade, os serviços e os profissionais.',
      ServicePackageNotFound: 'Este pacote já não existe.',
      ServicePackageInactive: 'Este pacote está inativo e não pode ser vendido.',
      CustomerServicePackageAlreadyActive: 'Este cliente já tem uma cópia ativa deste pacote. Tem de ser esgotada, expirar ou ser cancelada antes de voltar a vendê-lo.',
      CustomerServicePackageNotFound: 'Este pacote do cliente já não existe.',
      StorePayOnBookingDisabled: 'A venda de pacotes na loja está desativada nas definições de pagamento.',
      PlanUpgradeRequired: 'Os pacotes de serviços estão disponíveis no plano Pro. Faça o upgrade para os desbloquear.',
    },
    feedback: {
      created: 'Pacote criado.',
      updated: 'Pacote atualizado.',
      activated: 'Pacote ativado.',
      deactivated: 'Pacote desativado.',
    },
    actions: {
      edit: 'Editar pacote',
      activate: 'Ativar pacote',
      deactivate: 'Desativar pacote',
    },
    status: {
      active: 'Ativo',
      inactive: 'Inativo',
    },
    card: {
      unnamed: 'Pacote sem nome',
      price: 'Preço',
      quantity: '{{count}}x',
      expiresAfter_one: 'Expira {{count}} mês após a compra',
      expiresAfter_other: 'Expira {{count}} meses após a compra',
      noExpiry: 'Sem validade',
      includedServices: 'Serviços',
      professionals: 'Profissionais',
      anyProfessional: 'Qualquer profissional',
      activeHolders: 'Clientes ativos',
      removedService: 'Serviço removido',
    },
    activate: {
      title: 'Ativar pacote?',
      message: 'Os clientes voltarão a poder comprar {{name}}.',
      confirm: 'Ativar',
    },
    deactivate: {
      title: 'Desativar pacote?',
      message: 'Os clientes deixarão de poder comprar {{name}}. Quem já o comprou pode continuar a usá-lo até se esgotar ou expirar.',
      confirm: 'Desativar',
    },
    dialog: {
      createTitle: 'Novo pacote',
      editTitle: 'Editar pacote',
      saveCreate: 'Criar pacote',
      saveEdit: 'Guardar alterações',
    },
    fields: {
      name: 'Nome do pacote',
      price: 'Preço',
      quantity: 'Utilizações',
      quantityHelp: 'Cada marcação usa uma, independentemente de quantos serviços do pacote inclua.',
      expiresInMonths: 'Expira em (meses)',
      expiresInMonthsPlaceholder: 'Sem validade',
      expiresInMonthsHelp: 'Deixe vazio para não ter validade. Os clientes são avisados antes de comprar.',
      includedServices: 'Serviços incluídos',
      includedServicesHelp: 'Uma marcação só é coberta quando todos os seus serviços estão no pacote.',
      noServicesAvailable: 'Ainda não há serviços ativos para incluir.',
      includedProfessionals: 'Profissionais',
      includedProfessionalsHelp: 'Deixe todos desmarcados para permitir qualquer profissional que realize estes serviços. Marque profissionais específicos para restringir este pacote a esses membros.',
      noProfessionalsAvailable: 'Não há profissionais disponíveis.',
    },
    validation: {
      nameRequired: 'Introduza o nome do pacote em todos os idiomas suportados.',
      priceRequired: 'Introduza um preço superior a zero.',
      priceDecimals: 'O preço pode ter no máximo duas casas decimais.',
      quantityRequired: 'Introduza um número inteiro de utilizações entre 1 e 999.',
      expiresInMonthsInvalid: 'Introduza um número inteiro de meses entre 1 e 36, ou deixe vazio.',
      servicesRequired: 'Selecione pelo menos um serviço.',
    },
    customer: {
      title: 'Pacotes de serviços',
      sell: 'Vender pacote',
      sellUnavailable: 'A venda de pacotes na loja está desativada nas definições de pagamento.',
      empty: 'Este cliente não tem pacotes ativos.',
      remaining: '{{remaining}} de {{total}} restantes',
      expiresOn: 'Expira a {{date}}',
      noExpiry: 'Sem validade',
      purchasedOn: 'Comprado a {{date}}',
      channel: {
        Online: 'Online',
        InStore: 'Na loja',
      },
      pastPackages: 'Pacotes anteriores ({{count}})',
      effectiveStatus: {
        PendingCheckout: 'A aguardar pagamento',
        Active: 'Ativo',
        Exhausted: 'Esgotado',
        Expired: 'Expirado',
        Canceled: 'Cancelado',
        Refunded: 'Reembolsado',
        CheckoutExpired: 'Pagamento expirado',
      },
      cancel: {
        action: 'Cancelar pacote',
        title: 'Cancelar este pacote?',
        message: 'O cliente deixará de poder marcar com {{name}}. As marcações já feitas com ele mantêm a cobertura. Isto não reembolsa o cliente.',
        confirm: 'Cancelar pacote',
        success: 'Pacote cancelado.',
        error: 'Falha ao cancelar o pacote.',
      },
    },
    customerPackages: {
      error: {
        loading: 'Falha ao carregar os pacotes dos clientes.',
      },
      filter: {
        label: 'Mostrar',
        current: 'Atuais',
        all: 'Todos',
      },
      empty: {
        title: 'Ainda não há pacotes de clientes',
        subtitle: 'Os pacotes que os seus clientes comprarem, online ou na loja, aparecerão aqui.',
        filtered: 'Nenhum pacote corresponde a este filtro.',
      },
      table: {
        customer: 'Cliente',
        package: 'Pacote',
        status: 'Estado',
        uses: 'Utilizações',
        channel: 'Canal',
        purchased: 'Comprado a',
        expires: 'Expira a',
        price: 'Preço',
        actions: 'Ações',
        unnamedCustomer: 'Cliente sem nome',
      },
    },
    sell: {
      title: 'Vender pacote',
      description: 'Registe um pacote que o cliente paga na loja. Pode ser usado nas marcações de imediato.',
      customer: 'Cliente',
      customerPlaceholder: 'Selecione um cliente',
      package: 'Pacote',
      packagePlaceholder: 'Selecione um pacote',
      noActivePackages: 'Não há pacotes ativos para vender. Crie um em Serviços > Pacotes.',
      summary: 'Resumo',
      confirm: 'Vender pacote',
      selling: 'A vender...',
      success: 'Pacote vendido.',
      error: 'Falha ao vender o pacote.',
      errors: {
        customerRequired: 'Selecione um cliente.',
        packageRequired: 'Selecione um pacote.',
      },
    },
    appointment: {
      coveredByPackage: 'Coberto por pacote',
      packageLabel: 'Pacote: {{name}}',
      packageNote: 'Usa 1 de {{name}}',
      changeToRegularMessage: 'Isto remove a cobertura do pacote da marcação, devolve a utilização ao pacote do cliente e aplica os preços regulares dos serviços. Esta ação não pode ser revertida.',
    },
  },
  servicesManagement: {
    tabs: {
      packages: 'Pacotes',
      customerPackages: 'Pacotes de Clientes',
      customerPackagesShort: 'Clientes',
    },
  },
  paymentSettingsPage: {
    customerPayments: {
      step3: {
        packages: 'Pacotes',
      },
    },
  },
  roles: {
    modal: {
      form: {
        categories: {
          servicePackages: 'Pacotes de serviços',
        },
      },
    },
  },
  dashboard: {
    kpis: {
      todayServicePackageRevenue: 'Vendas de pacotes hoje',
      monthServicePackageRevenue: 'Vendas de pacotes este mês',
    },
    activityTypes: {
      servicePackageSold: '{{customerName}} comprou {{planName}}',
      servicePackageRefunded: 'Reembolso de pacote a {{customerName}} ({{planName}})',
    },
  },
};

export const servicePackageManagementTranslationsEs = {
  servicePackagesManagement: {
    addNew: 'Añadir paquete',
    noPackages: 'Aún no hay paquetes',
    emptyHint: 'Crea un paquete prepago, como 10 cortes de pelo, que los clientes compran una vez y usan en sus reservas.',
    error: {
      noStoreSelected: 'No hay ninguna tienda seleccionada.',
      loading: 'No se pudieron cargar los paquetes.',
      create: 'No se pudo crear el paquete.',
      update: 'No se pudo actualizar el paquete.',
      activate: 'No se pudo activar el paquete.',
      deactivate: 'No se pudo desactivar el paquete.',
    },
    apiErrors: {
      InvalidServicePackageData: 'Algunos datos del paquete no son válidos. Revisa el nombre, el precio, los usos, la caducidad, los servicios y los profesionales.',
      ServicePackageNotFound: 'Este paquete ya no existe.',
      ServicePackageInactive: 'Este paquete está inactivo y no se puede vender.',
      CustomerServicePackageAlreadyActive: 'Este cliente ya tiene una copia activa de este paquete. Debe agotarse, caducar o cancelarse antes de volver a venderlo.',
      CustomerServicePackageNotFound: 'Este paquete del cliente ya no existe.',
      StorePayOnBookingDisabled: 'La venta de paquetes en la tienda está desactivada en la configuración de pagos.',
      PlanUpgradeRequired: 'Los paquetes de servicios están disponibles en el plan Pro. Mejora el plan para desbloquearlos.',
    },
    feedback: {
      created: 'Paquete creado.',
      updated: 'Paquete actualizado.',
      activated: 'Paquete activado.',
      deactivated: 'Paquete desactivado.',
    },
    actions: {
      edit: 'Editar paquete',
      activate: 'Activar paquete',
      deactivate: 'Desactivar paquete',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    card: {
      unnamed: 'Paquete sin nombre',
      price: 'Precio',
      quantity: '{{count}}x',
      expiresAfter_one: 'Caduca {{count}} mes después de la compra',
      expiresAfter_other: 'Caduca {{count}} meses después de la compra',
      noExpiry: 'Sin caducidad',
      includedServices: 'Servicios',
      professionals: 'Profesionales',
      anyProfessional: 'Cualquier profesional',
      activeHolders: 'Clientes activos',
      removedService: 'Servicio eliminado',
    },
    activate: {
      title: '¿Activar paquete?',
      message: 'Los clientes podrán volver a comprar {{name}}.',
      confirm: 'Activar',
    },
    deactivate: {
      title: '¿Desactivar paquete?',
      message: 'Los clientes ya no podrán comprar {{name}}. Quienes ya lo compraron pueden seguir usándolo hasta que se agote o caduque.',
      confirm: 'Desactivar',
    },
    dialog: {
      createTitle: 'Nuevo paquete',
      editTitle: 'Editar paquete',
      saveCreate: 'Crear paquete',
      saveEdit: 'Guardar cambios',
    },
    fields: {
      name: 'Nombre del paquete',
      price: 'Precio',
      quantity: 'Usos',
      quantityHelp: 'Cada reserva usa uno, independientemente de cuántos servicios del paquete incluya.',
      expiresInMonths: 'Caduca en (meses)',
      expiresInMonthsPlaceholder: 'Sin caducidad',
      expiresInMonthsHelp: 'Déjalo vacío para que no caduque. Los clientes reciben un aviso antes de comprar.',
      includedServices: 'Servicios incluidos',
      includedServicesHelp: 'Una reserva solo queda cubierta cuando todos sus servicios están en el paquete.',
      noServicesAvailable: 'Aún no hay servicios activos para incluir.',
      includedProfessionals: 'Profesionales',
      includedProfessionalsHelp: 'Deja todos sin marcar para permitir cualquier profesional que realice estos servicios. Marca profesionales específicos para restringir este paquete a esos miembros.',
      noProfessionalsAvailable: 'No hay profesionales disponibles.',
    },
    validation: {
      nameRequired: 'Introduce el nombre del paquete en todos los idiomas admitidos.',
      priceRequired: 'Introduce un precio mayor que cero.',
      priceDecimals: 'El precio puede tener como máximo dos decimales.',
      quantityRequired: 'Introduce un número entero de usos entre 1 y 999.',
      expiresInMonthsInvalid: 'Introduce un número entero de meses entre 1 y 36, o déjalo vacío.',
      servicesRequired: 'Selecciona al menos un servicio.',
    },
    customer: {
      title: 'Paquetes de servicios',
      sell: 'Vender paquete',
      sellUnavailable: 'La venta de paquetes en la tienda está desactivada en la configuración de pagos.',
      empty: 'Este cliente no tiene paquetes activos.',
      remaining: '{{remaining}} de {{total}} restantes',
      expiresOn: 'Caduca el {{date}}',
      noExpiry: 'Sin caducidad',
      purchasedOn: 'Comprado el {{date}}',
      channel: {
        Online: 'Online',
        InStore: 'En la tienda',
      },
      pastPackages: 'Paquetes anteriores ({{count}})',
      effectiveStatus: {
        PendingCheckout: 'Pendiente de pago',
        Active: 'Activo',
        Exhausted: 'Agotado',
        Expired: 'Caducado',
        Canceled: 'Cancelado',
        Refunded: 'Reembolsado',
        CheckoutExpired: 'Pago caducado',
      },
      cancel: {
        action: 'Cancelar paquete',
        title: '¿Cancelar este paquete?',
        message: 'El cliente ya no podrá reservar con {{name}}. Las reservas ya hechas con él mantienen su cobertura. Esto no reembolsa al cliente.',
        confirm: 'Cancelar paquete',
        success: 'Paquete cancelado.',
        error: 'No se pudo cancelar el paquete.',
      },
    },
    customerPackages: {
      error: {
        loading: 'No se pudieron cargar los paquetes de los clientes.',
      },
      filter: {
        label: 'Mostrar',
        current: 'Actuales',
        all: 'Todos',
      },
      empty: {
        title: 'Aún no hay paquetes de clientes',
        subtitle: 'Los paquetes que tus clientes compren, online o en la tienda, aparecerán aquí.',
        filtered: 'Ningún paquete coincide con este filtro.',
      },
      table: {
        customer: 'Cliente',
        package: 'Paquete',
        status: 'Estado',
        uses: 'Usos',
        channel: 'Canal',
        purchased: 'Comprado el',
        expires: 'Caduca el',
        price: 'Precio',
        actions: 'Acciones',
        unnamedCustomer: 'Cliente sin nombre',
      },
    },
    sell: {
      title: 'Vender paquete',
      description: 'Registra un paquete que el cliente paga en la tienda. Se puede usar en reservas de inmediato.',
      customer: 'Cliente',
      customerPlaceholder: 'Selecciona un cliente',
      package: 'Paquete',
      packagePlaceholder: 'Selecciona un paquete',
      noActivePackages: 'No hay paquetes activos para vender. Crea uno en Servicios > Paquetes.',
      summary: 'Resumen',
      confirm: 'Vender paquete',
      selling: 'Vendiendo...',
      success: 'Paquete vendido.',
      error: 'No se pudo vender el paquete.',
      errors: {
        customerRequired: 'Selecciona un cliente.',
        packageRequired: 'Selecciona un paquete.',
      },
    },
    appointment: {
      coveredByPackage: 'Cubierto por paquete',
      packageLabel: 'Paquete: {{name}}',
      packageNote: 'Usa 1 de {{name}}',
      changeToRegularMessage: 'Esto elimina la cobertura del paquete de la reserva, devuelve el uso al paquete del cliente y aplica los precios regulares de los servicios. Esta acción no se puede deshacer.',
    },
  },
  servicesManagement: {
    tabs: {
      packages: 'Paquetes',
      customerPackages: 'Paquetes de Clientes',
      customerPackagesShort: 'Clientes',
    },
  },
  paymentSettingsPage: {
    customerPayments: {
      step3: {
        packages: 'Paquetes',
      },
    },
  },
  roles: {
    modal: {
      form: {
        categories: {
          servicePackages: 'Paquetes de servicios',
        },
      },
    },
  },
  dashboard: {
    kpis: {
      todayServicePackageRevenue: 'Ventas de paquetes hoy',
      monthServicePackageRevenue: 'Ventas de paquetes este mes',
    },
    activityTypes: {
      servicePackageSold: '{{customerName}} compró {{planName}}',
      servicePackageRefunded: 'Reembolso de paquete a {{customerName}} ({{planName}})',
    },
  },
};
